<template>
    <div id="ioPanoramicViewer" class="intraoral-flex-item">
        <div id="ioPanoramicViewport" class="ioPanoramic viewport">
            <div id="ioPanoramicContent" class="content">
                <img id="ioPanoramicImg" />
                <div id="ioPanoramicDiv"></div>
            </div>

            <div class="pano-zoom-container">
                <img src="images/white_plus.png" class="pano-zoom-btn" v-on:click="changeZoom(-1)"
                    title="Increase Zoom" />
                <img src="images/white_minus.png" class="pano-zoom-btn" v-on:click="changeZoom(1)"
                    title="Decrease Zoom" />
                <img id="btnIoPanoZoomReset" src="images/refresh.png" class="pano-zoom-btn" v-on:click="resetZoom()"
                    title="Reset Zoom" />
            </div>

            <img id="ioPanoOverlayVisibleImg" title="Overlay" v-on:click="panoOverlayVisibleClick()"
                :src="viewMode.panoOverlayVisible ? 'images/visible_on_white.png' : 'images/visible_off_white.png'">
        </div>
        <div id="ioPanoramicBottom" class="ioPanoramic">
            <div id="ioPanoramicMaxilla" class="ioPanoramic ioPanoRow">
                <div class="ioPanoItem" v-for="f in viewMode.panoMaxItems" @mouseover="mouseOverPanItem(f)"
                    @mouseleave="mouseLeavePanItem(f)">
                    <img class="ioPanImg ioPanImgMax" :src="`images/pano_teeth/tooth_${f.id}_${f.icon_color}.png`">
                    <div class="ioPanLb ioPanLbMax">{{ f.id }}</div>
                </div>
            </div>
            <div id="ioPanoramicMandible" class="ioPanoramic ioPanoRow">
                <div class="ioPanoItem" v-for="f in viewMode.panoMandItems" @mouseover="mouseOverPanItem(f)"
                    @mouseleave="mouseLeavePanItem(f)">
                    <img class="ioPanImg ioPanImgMand" :src="`images/pano_teeth/tooth_${f.id}_${f.icon_color}.png`">
                    <div class="ioPanLb ioPanLbMand">{{ f.id }}</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { viewMode } from "./IntraoralManager";

let viewport; //= document.getElementById("viewport");
let content;// = document.getElementById("content");
// State
const state = {
    scale: 1,
    pointX: 0,
    pointY: 0,
    panning: false,
    startX: 0,
    startY: 0,
    minScale: 0.1,
    maxScale: 10,
    lastTouchDist: null,
};

// Apply current transform to DOM
function updateTransform() {
    content.style.transform = `translate(${state.pointX}px, ${state.pointY}px) scale(${state.scale})`;
}

export default {
    name: "IntraoralPanoramic",
    data() {
        return {
            // topNumbers: [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28],
            // bottomNumbers: [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38],
        }
    },
    props: {
        viewMode: {
            type: Object,
            required: true
        },
    },
    mounted() {
        viewport = document.getElementById("ioPanoramicViewport");
        content = document.getElementById("ioPanoramicContent");

        // Initial render // --- MOUSE WHEEL ZOOM ---
        viewport.addEventListener(
            "wheel",
            (e) => {
                e.preventDefault();

                const rect = viewport.getBoundingClientRect();
                const mouseX = e.clientX - rect.left;
                const mouseY = e.clientY - rect.top;
                console.log("viewport wheel", rect, e, mouseX, mouseY);

                // Step zoom: scroll up = zoom in, scroll down = zoom out
                const zoomFactor = e.deltaY > 0 ? 0.9 : 1.1;
                const newScale = Math.min(
                    state.maxScale,
                    Math.max(state.minScale, state.scale * zoomFactor),
                );

                // Zoom towards cursor position
                const scaleRatio = newScale / state.scale;
                state.pointX = mouseX - (mouseX - state.pointX) * scaleRatio;
                state.pointY = mouseY - (mouseY - state.pointY) * scaleRatio;
                state.scale = newScale;

                updateTransform();
            },
            { passive: false },
        );

        // --- MOUSE DRAG PAN ---
        viewport.addEventListener("mousedown", (e) => {
            e.preventDefault();
            state.panning = true;
            state.startX = e.clientX - state.pointX;
            state.startY = e.clientY - state.pointY;
            viewport.classList.add("dragging");
        });

        window.addEventListener("mousemove", (e) => {
            if (!state.panning) return;
            e.preventDefault();
            state.pointX = e.clientX - state.startX;
            state.pointY = e.clientY - state.startY;
            updateTransform();
        });

        window.addEventListener("mouseup", () => {
            state.panning = false;
            viewport.classList.remove("dragging");
        });

        // --- TOUCH PAN & PINCH ZOOM ---
        viewport.addEventListener(
            "touchstart",
            (e) => {
                if (e.touches.length === 1) {
                    state.panning = true;
                    state.startX = e.touches[0].clientX - state.pointX;
                    state.startY = e.touches[0].clientY - state.pointY;
                } else if (e.touches.length === 2) {
                    state.panning = false;
                    state.lastTouchDist = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY,
                    );
                }
            },
            { passive: false },
        );

        viewport.addEventListener(
            "touchmove",
            (e) => {
                e.preventDefault();

                if (e.touches.length === 1 && state.panning) {
                    state.pointX = e.touches[0].clientX - state.startX;
                    state.pointY = e.touches[0].clientY - state.startY;
                    updateTransform();
                } else if (e.touches.length === 2 && state.lastTouchDist) {
                    const currentDist = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY,
                    );

                    const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                    const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                    const rect = viewport.getBoundingClientRect();
                    const pivotX = centerX - rect.left;
                    const pivotY = centerY - rect.top;

                    const scaleRatio = currentDist / state.lastTouchDist;
                    const newScale = Math.min(
                        state.maxScale,
                        Math.max(state.minScale, state.scale * scaleRatio),
                    );

                    state.pointX =
                        pivotX - (pivotX - state.pointX) * (newScale / state.scale);
                    state.pointY =
                        pivotY - (pivotY - state.pointY) * (newScale / state.scale);
                    state.scale = newScale;
                    state.lastTouchDist = currentDist;

                    updateTransform();
                }
            },
            { passive: false },
        );

        viewport.addEventListener("touchend", () => {
            state.panning = false;
            state.lastTouchDist = null;
        });

        // --- RESET ---
        // resetBtn.addEventListener("click", () => {
        //     state.scale = 1;
        //     state.pointX = 0;
        //     state.pointY = 0;
        //     updateTransform();
        // });

        updateTransform();
    },
    methods: {
        changeZoom: function (factor) {
            const rect = viewport.getBoundingClientRect();
            const mouseX = rect.width / 2; //e.clientX - rect.left;
            const mouseY = rect.height / 2; //e.clientY - rect.top;

            // Step zoom: scroll up = zoom in, scroll down = zoom out
            const zoomFactor = factor > 0 ? 0.9 : 1.1;
            const newScale = Math.min(
                state.maxScale,
                Math.max(state.minScale, state.scale * zoomFactor),
            );

            // Zoom towards cursor position
            const scaleRatio = newScale / state.scale;
            state.pointX = mouseX - (mouseX - state.pointX) * scaleRatio;
            state.pointY = mouseY - (mouseY - state.pointY) * scaleRatio;
            state.scale = newScale;

            updateTransform();
        },
        resetZoom: function () {
            state.scale = 1;
            state.pointX = 0;
            state.pointY = 0;
            updateTransform();
        },
        panoOverlayVisibleClick: function () {
            this.viewMode.panoOverlayVisible = !this.viewMode.panoOverlayVisible;
            const ioDiv = document.getElementById("ioPanoramicDiv");
            ioDiv.style.display = this.viewMode.panoOverlayVisible ? "block" : "none";
        },
        mouseOverPanItem: function (figure) {
            figure.icon_color = "orange";
            if (figure.item) {
                figure.item.isHovered = true;
            }
            // if (figure.panoShape) {
            //     figure.panoShape.opacity(1);
            // }
        },
        mouseLeavePanItem: function (figure) {
            let isFocused = figure.item && figure.item.isFocused;
            if (!isFocused) {
                figure.icon_color = figure.item ? "blue" : "white";

                if (figure.item) {
                    figure.item.isHovered = false;
                }
            }

            // if (figure.panoShape) {
            //     figure.panoShape.opacity(0.5);
            // }
        },
    }
}
</script>

<style scoped>
#ioPanoramicViewer {
    display: none;
    height: 100%;
    text-align: center;
    position: relative;
    flex-grow: 1;
}

.ioPanoramic {
    position: absolute;
    left: 0;
    width: 100%;
}

#ioPanoramicViewport {
    top: 0;
    height: 70%;
    background: black;
    overflow: hidden;
    cursor: grab;
    touch-action: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.content {
    width: 100%;
    height: 100%;
    /* Critical: transform must originate from top-left for the math to work */
    transform-origin: 0 0;
    will-change: transform;
    /* display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; */
    user-select: none;
    /* Prevents text highlighting while dragging */
    /* background-color: red; */
}

#ioPanoramicBottom {
    top: 70%;
    height: 30%;
    background: white;
}

#ioPanoramicImg {
    position: absolute;
    top: 9%;
    left: 0;
    width: 100%;
    /* height: 100%;
    object-fit: contain; */
}

#ioPanoramicDiv {
    position: absolute;
    top: 9%;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: blue; */
    /* opacity: 0.3; */
}

#ioPanoOverlayVisibleImg {
    position: absolute;
    width: 28px;
    height: 28px;
    top: 7px;
    right: 10px;
    cursor: pointer;
}

.pano-zoom-container {
    position: absolute;
    text-align: center;
    height: 35px;
    left: 17px;
    top: 17px;
    z-index: 2;
}

.pano-zoom-btn {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    color: white;
    cursor: pointer;
    display: inline-block;
    /* font-size: 2rem; */
}

#btnIoPanoZoomReset {
    margin-top: -1px;
    width: 27px;
    height: 27px;
}

#ioPanoramicMaxilla {
    top: 0%;
    height: 50%;
    /* background: red; */
}

#ioPanoramicMandible {
    top: 50%;
    height: 50%;
    /* background: green; */
}

.ioPanoRow {
    display: flex;
    justify-content: flex-start;
}

.ioPanoItem {
    box-sizing: border-box;
    width: 12.5%;
    height: 100%;
    border: solid #082F5E 1px;
    position: relative;
    cursor: pointer;
}

.ioPanImg {
    position: absolute;
    left: 0;
    width: 100%;
    aspect-ratio: 1 / 2;
    margin: 0;
}

.ioPanImgMax {
    top: 2%;
}

.ioPanImgMand {
    bottom: 0px;
}

.ioPanLb {
    width: 100%;
    text-align: center;
    margin: 0;
    position: absolute;
    left: 0;
    /* font-weight: bold; */
    /* margin-top: 10%; */
}

.ioPanLbMax {
    bottom: 1%;
}

.ioPanLbMand {
    top: 2%;
}
</style>
